/**
 * Blob Source (`blob.source`) constants and its mode rule, kept apart from the
 * inspector component so the component file exports components only.
 */

/** The query a new node starts with (mirrors the backend's DEFAULT_QUERY). */
export const DEFAULT_BLOB_QUERY = "SELECT * FROM blobs ORDER BY path";

/** The fixed columns of `blobs`. Blob metadata adds `meta_<key>` columns. */
export const BLOBS_COLUMNS = [
  "name",
  "path",
  "folder",
  "extension",
  "size_bytes",
  "last_modified",
  "created",
  "content_type",
  "etag",
] as const;

/** Which mode a node is in — the same rule the engine applies
 *  (`blob_source_mode`): an explicit `mode` wins; a saved node with a `path`
 *  and no query is a data-file node; everything else is a document list. */
export function blobSourceMode(config: Record<string, unknown>): "documents" | "file" {
  const mode = String(config.mode ?? "");
  if (mode === "documents" || mode === "file") return mode;
  const path = String(config.path ?? "").trim();
  const query = String(config.query ?? "").trim();
  return path && !query ? "file" : "documents";
}
